import React from "react";

/**
 * COLLATION WATCH brand mark
 * Renders the official logo PNG (eye + magnifier + wordmark + tagline).
 * - `variant="lockup"` (default): full logo. Height = `size`, width scales to preserve aspect.
 * - `variant="icon"`: crops to the top ~55% (icon only, no wordmark). Height = `size`.
 */
export default function BrandMark({ size = 32, variant = "lockup", className = "", ...rest }) {
  const isIcon = variant === "icon";
  if (isIcon) {
    return (
      <span
        className={`inline-block ${className}`}
        style={{ height: size, width: size * 1.35, overflow: "hidden" }}
        aria-label="Collation Watch"
        role="img"
        {...rest}
      >
        <img
          src="/collation-watch-logo.png"
          alt="Collation Watch"
          draggable={false}
          style={{
            height: size * 1.85,
            width: "auto",
            objectPosition: "center top",
            display: "block",
            marginTop: `-${size * 0.05}px`,
          }}
        />
      </span>
    );
  }
  return (
    <img
      src="/collation-watch-logo.png"
      alt="Collation Watch"
      draggable={false}
      className={className}
      style={{ height: size, width: "auto", display: "block" }}
      aria-label="Collation Watch"
      {...rest}
    />
  );
}
